import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const setObserver = () => {
  const adi_sgdt_evaluations = document.querySelector('#adi_sgdt_evaluations');
  const add_adi_sgdt_re_evaluation = document.querySelector('#add_adi_sgdt_re_evaluation');

  if (adi_sgdt_evaluations) {
    adi_sgdt_evaluations.addEventListener('click', () => onSubmit(adi_sgdt_evaluations.dataset));
  }

  if (add_adi_sgdt_re_evaluation) {
    add_adi_sgdt_re_evaluation.addEventListener('click', () => addReEvaluation(add_adi_sgdt_re_evaluation.dataset));
  }
};

const checkForm = (form = {}) => {
  const { cf, nrCartella } = form;
  const response = { cf, nr_cartella: nrCartella };

  return response.cf && response.nr_cartella ? response : null;
};

const onSubmit = async (form) => {
  let params = checkForm(form);

  if (!params) return;

  const baseUrl = window.config.ePersonamService.ePersonamHost + '/' + window.locale;
  const sessionUrl = `${baseUrl}/adi_sgdt/adi_sgdt/adi_sgdt_activation_session`;

  try {
    Loader.show();
    const { data } = await apiConnector().post(sessionUrl, params);

    data.url ? window.open(data.url, '_self') : retrieve();
  } catch (exception) {
    console.error(exception);
  } finally {
    Loader.hide();
  }
};

const addReEvaluation = async (dataset) => {
  if (!dataset) {
    alert('Parametro non presente.');
    return;
  }

  eventBus.$emit('sgdtReevaluationForm', dataset);
};

const retrieve = async () => {
  const baseUrl = window.config.ePersonamService.ePersonamHost + '/' + window.locale;
  const retrieveUrl = `${baseUrl}/adi_sgdt/adi_sgdt/retrieve_evaluations.json`;

  try {
    Loader.hide();
    const { data } = await apiConnector().post(retrieveUrl);

    if (data.url) {
      window.open(data.url, '_self');
    }
  } catch (e) {
    console.error(e);
  } finally {
    Loader.hide();
  }
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.AdiSgdt = {
  init: init,
};
